import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Subject, throwError } from 'rxjs';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserFib4Service {
  error = new Subject<string>();
  slug = '/user_fib4s';
  resourceName = 'user_fib4s';
  allFib4s?: any;
  fib4sBetween?: any;

  constructor(private http: HttpClient) {}

  fetchAll(): any {
    if (!this.allFib4s) {
      this.allFib4s = this.http
        .get<any>(environment.apiUrl + this.slug, {
          responseType: 'json',
        })
        .pipe(
          map((responseData) => {
            const returnArray: any[] = [];
            responseData['_embedded'][this.resourceName].forEach(
              (item: any) => {
                returnArray.push(item);
              }
            );
            return returnArray;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount()
        );
    }

    return this.allFib4s;
  }

  clearCache() {
    this.allFib4s = null;
    this.fib4sBetween = null;
  }

  fetch(id: number) {
    return this.http
      .get<any>(environment.apiUrl + this.slug + '/' + id, {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          return responseData;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  create(fib4: string, date_recorded: string) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      fib4,
    };
    return this.http.post<any>(environment.apiUrl + this.slug, payload, {
      observe: 'response',
    });
  }

  update(id: number, fib4: string, date_recorded: string) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      fib4,
    };
    return this.http.patch<any>(
      environment.apiUrl + this.slug + '/' + id,
      payload,
      {
        observe: 'response',
      }
    );
  }

  delete(id: number) {
    this.clearCache();
    return this.http.delete<{ name: string }>(
      environment.apiUrl + this.slug + '/' + id
    );
  }

  getGoodFib4(age, gender) {
    if (age < 50) {
      if (gender == 'm') {
        return 27;
      }
      if (gender == 'f') {
        return 27;
      }
    } else if (age > 49 && age < 60) {
      if (gender == 'm') {
        return 27;
      }
      if (gender == 'f') {
        return 24;
      }
    } else if (age > 59 && age < 70) {
      if (gender == 'm') {
        return 26;
      }
      if (gender == 'f') {
        return 24;
      }
    } else if (age > 69 && age < 80) {
      if (gender == 'm') {
        return 23;
      }
      if (gender == 'f') {
        return 23;
      }
    }
  }

  getTypical(fib4, gender) {
    if (gender == 'm') {
      switch (+fib4) {
        case 27:
          return '20 - 59';
          break;
        case 26:
          return '60 - 69';
          break;
        case 23:
          return '70 - 80';
          break;
      }
    } else if (gender == 'f') {
      switch (+fib4) {
        case 27:
          return '20 - 49';
          break;
        case 24:
          return '50 - 69';
          break;
        case 23:
          return '70 - 80';
          break;
      }
    }
  }

  getRag(fib4) {
    let ragColour = '';

    if (+fib4 < 1.3) {
      ragColour = 'green';
    } else if (+fib4 > 2.67) {
      ragColour = 'red';
    } else {
      ragColour = 'amber';
    }

    return ragColour;
  }

  getRangeforColor(colour: string) {
    let ragRange = '';
    if (colour == 'green') {
      ragRange = '<1.3';
    } else if (colour == 'amber') {
      ragRange = '1.3-2.67';
    } else {
      ragRange = '>2.67';
    }

    return ragRange;
  }
}
